'use strict';

module.exports = function plaintextToMindmupArray(plaintext) {
	if (!plaintext) {
		return;
	}
	const lastNodesByLevel = [],
		ideaArray = [],
		findParent = (level) => {
			const potential = lastNodesByLevel.slice(0, level);
			return potential.reverse().find(item => item);
		},
		pushIdea = (level, text) => {
			const ideaToPush = {title: text},
				parent = findParent(level);
			if (!level || !parent) {
				ideaArray.push(ideaToPush);
			} else {
				parent.ideas = parent.ideas || {};
				parent.ideas[Object.keys(parent.ideas).length + 1] = ideaToPush;
			}
			lastNodesByLevel[level] = ideaToPush;
		},
		parseLine = (line) => {
			const trimmedLine = line.trim(),
				tabPrefixMatch = line.match(/^\t*/),
				lineLevel = tabPrefixMatch[0].length,
				lineComponents = trimmedLine.split(/\t+/);
			if (!trimmedLine) {
				return;
			}
			lineComponents.forEach((component, index) => {
				pushIdea(lineLevel + index, component);
			});
		},
		lines = plaintext.split('\n');

	lines.forEach(parseLine);
	return ideaArray.length && ideaArray;
};
